<template>
    <div id="contents">
      <div class="inner">
        <h3 class="main-title">공지사항</h3>
        <article class="common-txt-wrap notice">
          <ul>
            <li v-for="(item,index) in this.NoticeData" :key="index">
              <button type="button" class="list-box open-layer" v-on:click="this.handlePopup(index)">
                <h4 class="list-title">{{item.title}}</h4>
                <p class="list-date">{{item.date}}</p>
              </button>
            </li>
          </ul>
        </article>
      </div>
    </div>
  <Popup v-if="popState" @close="changePopState()" v-bind:popupData="this.popupData"/>
</template>
<script>
import Popup from './popup/Popup'
import NoticeData from '@/data/Notice-data.json'

export default {
  name: 'page-notice',
  components: {
    Popup
  },
  data() {
    return {
      popState: false,
      popupData: {},
      NoticeData: NoticeData.notices,
      curWidth: 2.5
    }
  },
  methods: {
    changePopState() {
      this.popState = !this.popState;
    },
    handlePopup(index) {
      this.popupData = this.NoticeData[index];
      this.changePopState();
    },
    scroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || window.screenY;
      document.querySelectorAll("article").forEach(item => {
        if(scrollTop > item.offsetTop - window.innerHeight / this.curWidth){
          item.classList.add("on");
        }
      });
      window.requestAnimationFrame(this.scroll);
    }
  },
  mounted() {
    if (document.body.clientWidth < 800) {
      this.curWidth = 1
    }
    document.body.classList.add('sub');
    this.scroll();
  }

}
</script>
